import type { DragEvent } from 'react';

const setResourceDragImage = (event: DragEvent, type: 'agent' | 'project', name: string) => {
	const preview = document.createElement('div');
	const icon = document.createElement('span');
	const label = document.createElement('strong');
	const sourceIcon = (
		event.currentTarget.querySelector('[data-drag-preview-icon] svg') || event.currentTarget.querySelector('svg')
	)?.cloneNode(true);
	preview.className =
		'fixed -left-[1000px] top-0 z-notification flex h-8 max-w-52 items-center gap-2 rounded-control border border-border bg-surface-raised px-2.5 text-xs text-foreground shadow-flyout';
	icon.className = 'flex size-4 items-center justify-center text-foreground-nav';
	if (sourceIcon) icon.append(sourceIcon);
	else icon.textContent = type === 'agent' ? '✦' : '◇';
	label.className = 'truncate';
	label.textContent = name;
	preview.append(icon, label);
	document.body.append(preview);
	event.dataTransfer.setDragImage(preview, 16, 16);
	window.requestAnimationFrame(() => preview.remove());
};

export { setResourceDragImage };
